import React from "react";
import about1Img from "../../../assets/Images/about/about-1.jpg";
import qualityAssuredImg from "../../../assets/Images/home/quality-assured.svg";
import embracingHealthImg from "../../../assets/Images/home/embracing-health.svg";
import upholdingHumanityImg from "../../../assets/Images/home/upholding-humanity.svg";

export default function First_AboutUs_Section({
  teamImageSrc = about1Img,
  features = [
    {
      iconSrc: qualityAssuredImg,
      title: "NATURALLY POWERFUL",
      description:
        "Our products are crafted using premium-quality ingredients with science-backed wellness solutions.",
    },
    {
      iconSrc: embracingHealthImg,
      title: "EXPERTLY CRAFTED",
      description:
        "Every formulation is developed with precision, innovation, and expert nutraceutical knowledge.",
    },
    {
      iconSrc: upholdingHumanityImg,
      title: "AFFORDABLE",
      description:
        "Delivering accessible wellness solutions without compromising quality or effectiveness.",
    },
  ],
}) {
  const brandGreen = "#355931";
  const bodyText = "#4B5563";
  const cardBg = "#F5F8F2";
  const badgeBg = "#E4ECD8";

  return (
    <section className="w-full bg-white py-14 sm:py-16 lg:py-20 overflow-hidden">

      {/* INLINE CSS */}
      <style>{`
        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .about-image img {
          transition: transform 0.7s ease;
        }

        .about-image:hover img {
          transform: scale(1.03);
        }

        .feature-card {
          transition: all 0.4s ease;
        }

        .feature-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.06);
        }

        .feature-icon img {
          transition: transform 0.4s ease;
        }

        .feature-card:hover .feature-icon img {
          transform: scale(1.08);
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">

          {/* LEFT IMAGE */}
          <div className="w-full">

            {/* Small Label */}
            <p className="text-[#A4BE2C] tracking-[0.35em] text-[11px] font-semibold mb-4 uppercase">
              About Nutralike
            </p>

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-[#355931] leading-tight mb-6">
              Empowering Health Through <br />
              <span className="gradient-text">
                Trusted Manufacturing
              </span>
            </h2>

            
          {/* Underline */}
          <div
            className="w-24 h-[2px] mx-auto mt-6 mb-6"
            style={{
              background:
                "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
            }}
          />
          
            {/* Image */}
            <div className="about-image rounded-[28px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.08)]">
              <img
                src={teamImageSrc}
                alt="Nutralike Team and Manufacturing"
                className="w-full h-full object-cover"
              />
            </div>

          </div>

          {/* RIGHT CONTENT */}
          <div className="flex flex-col justify-center">

            {/* Description */}
            <div
              className="space-y-5 text-[15px] sm:text-base leading-relaxed"
              style={{ color: bodyText }}
            >
              <p>
                <span
                  className="font-bold"
                  style={{ color: brandGreen }}
                >
                  NUTRALIKE
                </span>{" "}
                Group was founded in 2014 with a strong vision to create
                high-quality and affordable nutraceutical solutions for
                humanity. With innovation, commitment, and manufacturing
                excellence, Nutralike has become one of the fastest-growing
                third-party nutraceutical manufacturing companies.
              </p>

              <p>
                Our advanced manufacturing facility is organized into multiple
                specialized production divisions focused on delivering
                precision-driven wellness products with international quality
                standards.
              </p>

              <p>
                The Nutralike Group proudly operates a large-scale manufacturing
                infrastructure spanning over 80,000 square feet across multiple
                floors, enabling scalable production and continuous innovation.
              </p>
            </div>

            {/* Divider */}
            <div className="w-full h-[1px] bg-gray-200 my-8" />

            {/* Feature Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-2">

              {features.map((feature, i) => (
                <div
                  key={i}
                  className="
                    feature-card
                    rounded-2xl
                    p-1 sm:p-3                    
                    flex
                    flex-col
                    justify-start
                    min-h-[210px]
                  "
                  style={{ backgroundColor: cardBg }}
                >

                  {/* Icon */}
                  <div
                    className="
                      feature-icon
                      w-12
                      h-12
                      rounded-full
                      flex
                      items-center
                      justify-center
                      mb-4
                      flex-shrink-0
                    "
                    style={{ backgroundColor: badgeBg }}
                  >
                    <img
                      src={feature.iconSrc}
                      alt=""
                      className="w-7 h-7 object-contain"
                    />
                  </div>

                  {/* Title */}
                  <h3
                    className="
                      text-[15px]
                      sm:text-base
                      font-bold
                      leading-snug
                      mb-2
                      uppercase
                    "
                    style={{ color: brandGreen }}
                  >
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p
                    className="
                      text-[13px]
                      sm:text-[14px]
                      leading-relaxed
                      flex-grow
                    "
                    style={{ color: bodyText }}
                  >
                    {feature.description}
                  </p>

                </div>
              ))}

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}